<template>
  <b-container fluid>
    <div class="teachers">
      <h1>Teachers</h1>
      <div v-if="!isLoading" class="table-wrap">
        <div>
          <router-link
            v-if="isAdmin"
            :to="{ name: 'NewTeacher' }"
            class="add_teacher_link"
            >+Add Teacher</router-link
          >
        </div>
        <br />
        <b-row>
          <b-col v-if="isAdmin">
            <name-search
              table="teachers-list"
              parent="teachers-list"
            ></name-search>
            <b-button @click="resetList" class="mb-2">Reset Search</b-button>
          </b-col>
          <b-col md="6" class="my-1">
            <b-form-group horizontal label="Per page">
              <b-form-select :options="pageOptions" v-model="perPage" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-table
          v-cloak
          responsive
          :fields="fields"
          :items="teachers"
          :striped="true"
          :bordered="true"
          :hover="true"
          stacked="md"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
        >
          <template slot="cell(teacher_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditTeacher', params: { id: row.item.tuuid } }"
              >{{ row.value }}</b-link
            >
          </template>
          <template slot="cell(school_name)" slot-scope="row">
            <b-link
              @click.stop="stopClick"
              :to="{ name: 'EditSchool', params: { id: row.item.suuid } }"
              >{{ row.value }}</b-link
            >
          </template>
          <template slot="cell(head_teacher)" slot-scope="row">{{
            row.item.head_teacher === true ? "Y" : "N"
          }}</template>
          <template slot="cell(active)" slot-scope="row">
            <b-form-radio-group
              v-if="isAdmin"
              :id="row.index.toString()"
              :value="row.item.active"
              v-model="row.item.active"
              @change="updateTeacherActive(row.item)"
            >
              <b-form-radio :value="true">True</b-form-radio>
              <b-form-radio :value="false">False</b-form-radio>
            </b-form-radio-group>
          </template>
          <template slot="cell(duplicate)" slot-scope="row">
            <b-form-checkbox
              v-model="row.item.duplicate"
              name="duplicate"
              @change="updateTeacherDuplicate(row.item)"
              >Duplicate</b-form-checkbox
            >
          </template>
        </b-table>
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="totalRows || 0"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
          <download-button :export="exportData" :file="file"></download-button>
        </b-row>
      </div>
      <div v-else>
        <p>Teachers are loading...</p>
        <b-spinner></b-spinner>
        <br />
        <router-link v-bind:to="{ name: 'NewTeacher' }" class="add_teacher_link"
          >+Add Teacher</router-link
        >
      </div>
    </div>
  </b-container>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import DownloadButton from "@/components/DownloadButton";
import NameSearch from "@/components/NameSearch";
import TeacherService from "@/services/TeacherService";

export default {
  name: "TeachersList",
  components: {
    DownloadButton,
    NameSearch,
  },
  data() {
    return {
      file: this.$route.path.slice(1),
      fields: [
        {
          key: "teacher_name",
          label: "Full Name",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "school_name", label: "School", sortable: true },
        { key: "sex", label: "Sex", sortable: true },
        { key: "head_teacher", label: "Head Teacher", sortable: true },
        { key: "active", label: "Active", sortable: true },
        { key: "duplicate", label: "Duplicate", sortable: true },
      ],
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      exportData: [],
      isLoading: true,
    };
  },
  async created() {
    await this.GET_TEACHERS();
    this.isLoading = false;
    this.exportData = await this.teachersExport();
  },
  mounted() {
    // this.exportData = this.teachersExport();
  },
  methods: {
    ...mapActions({
      GET_TEACHERS: "teachers/GET_TEACHERS",
      RESET_SEARCH_STATE: "searches/RESET_SEARCH_STATE",
    }),
    async resetList() {
      await this.RESET_SEARCH_STATE();
      await this.GET_TEACHERS();
    },
    stopClick(row) {},
    async teachersExport() {
      const data = await this.teachers.map((t) => {
        return {
          "1 - Teacher name": `${t.teacher_name}`,
          "2 - Trainer name": `${t.trainer_name}`,
          "3 - sex": t.sex,
          // "3 - birthdate": t.birthdate,
          "4 - Country": t.country,
          "5 - Region": t.region,
          "6 - District": t.district,
          // "4 - mobile_1": t.mobile_1,
          "7 - school name": t.school_name,
          "8 - mobile_1": t.mobile_1,
          "9 - mobile_2": t.mobile_2,
          // '7 - current school': t.currentSchool.name,
          // '8 - previous schools': s.name,
          "10 - education_primary": t.education_primary,
          "11 - education_secondary": t.education_secondary,
          "12 - education_diploma": t.education_diploma,
          "13 - education_degree": t.education_degree,
          // '13 - total students': t.students.length,
          // "14 - modules introduction": t.modules_introduction,
          // "15 - modules planning": t.modules_planning,
          // "16 - modules working_with_parents": t.modules_working_with_parents,
          // "17 - modules language_and_communication":
          //   t.modules_language_and_communication,
          // "18 - modules perceptual_auditory": t.modules_perceptual_auditory,
          // "19 - modules perceptual_visual": t.modules_perceptual_visual,
          // "20 - modules body_image": t.modules_body_image,
          // "21 - modules inclusion_management": t.modules_inclusion_management,
          // "22 - modules activity_areas": t.modules_activity_areas,
          // "23 - modules learning": t.modules_learning,
          // "24 - modules hygiene": t.modules_hygiene,
          // "25 - modules environment": t.modules_environment,
          // "26 - modules safety_wellness": t.modules_safety_wellness,
          // "27 - modules school_prep1": t.modules_school_prep1,
          // "28 - modules gender_inclusion": t.modules_gender_inclusion,
          // "29 - modules school_prep2": t.modules_school_prep2,
        };
        return t;
      });
      return await data.reduce((acc, val) => acc.concat(val), []);
    },
    async updateTeacherActive(params) {
      const payload = await {
        id: params.tuuid,
        active: !params.active,
      };
      await TeacherService.updateTeacherActive(payload);
    },
    async updateTeacherDuplicate(params) {
      const payload = await {
        id: params.tuuid,
        user_flagged_duplicate: !params.duplicate,
      };
      await TeacherService.updateTeacherDuplicate(payload);
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
    }),
    teachers: {
      get() {
        return this.$store.state.teachers.teachers;
      },
    },
    totalRows() {
      return this.teachers.length;
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
};
</script>

<style scoped>
#teachers {
  table-layout: fixed;
  width: 100%;
  white-space: nowrap;
}
#name {
  width: 30%;
}
#sex {
  width: 10%;
}
#assigned-schools {
  width: 60%;
}
#edit {
  width: 10%;
}

.table-wrap {
  width: 60%;
  margin: 0 auto;
  text-align: center;
}
table th,
table tr {
  text-align: center;
}
table thead {
  background: #bf9660;
}
td {
  width: 100px;
  text-align: center;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #bf9660;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
a.add_teacher_link {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
}

.previous-schools {
  list-style-type: none;
  display: inline;
}
</style>
